import {
  Select,
  Option
} from 'element-ui'
console.log('el-select-proxy.js')

// 在键盘enter 选择select下拉菜单的回调做拦截
const oldSelectOptionFn = Select.methods.selectOption

Select.methods.selectOption = function (...arg) {
  selectProxy.apply(this, [oldSelectOptionFn, ...arg])
}

// 在鼠标点击 选择select下拉菜单的回调做拦截
const oldSelectOptionClickFn = Option.methods.selectOptionClick

Option.methods.selectOptionClick = function (...arg) {
  selectProxy.apply(this, [oldSelectOptionClickFn, ...arg])
}

const selectProxy = function (oldSelectOptionFn, ...arg) {
  let tableEditItemInstance = this.$parent
  let elSelectInstance = this

  oldSelectOptionFn.apply(this, arg)

  while(elSelectInstance && elSelectInstance.$options.name !== 'ElSelect'){
    elSelectInstance = elSelectInstance.$parent
  }

  if(elSelectInstance.multiple) return

  while(tableEditItemInstance && !tableEditItemInstance.isTableEditItem){
    tableEditItemInstance = tableEditItemInstance.$parent
  }

  if(tableEditItemInstance && tableEditItemInstance.isTableEditItem){
    elSelectInstance.$nextTick(() => {
      // element-ui 2.3.x版本后 select选择选项后不会主动失焦
      elSelectInstance.blur()
      tableEditItemInstance._editComponentBlur()
    })
  }
}
